import React from 'react';
import {PropTypes} from 'prop-types';
const multiStyle = {
   display: 'block',
   flexWrap: 'wrap'
};
const singleStyle = {
   display: 'inline-flex'
};
const ValueContainer = React.forwardRef(function ValueContainer(props, ref) {
   const {isMulti} = props;
   return (
      <div
         ref={ref}
         style={isMulti ? multiStyle : singleStyle}
         className={props.selectProps.classes.valueContainer}
      >
         {props.children}
      </div>
   );
});

ValueContainer.propTypes = {
   /**
    * The children to be rendered.
    */

   children: PropTypes.node,
   selectProps: PropTypes.object.isRequired
};
export default ValueContainer;
